import React from 'react'
// import CheckboxGroup from './CheckboxGroup'
import DatePicker from './DatePicker'
import Input from './Input'
// import RadioButtons from './RadioButtons'
import Select from './Select'
import SelectTable from './SelectTable'
import Textarea from './Textarea'
import FileUpload from './FileUpload'
import RadioButtons from './RadioButtons'
import FieldArrayTechExp from './FieldArrayTechExp'
import CheckboxGroup from './CheckboxGroup'
import CkEditer from './CkEditor'
import InputTable from './InputTable'
import CheckboxHorizantal from './CheckboxHorizantal'
import AutoCompleteSelect from './AutoCompleteSelect'
import Formikfield from './Formikfield'
import TimeControl from './TimeControl'
import MultiSelectOption from './MultiSelectOption'



function FormikControl(props) {
    const { control, ...rest } = props
    switch(control){
        case 'input'        : 
            return <Input {...rest}/>
        case 'textarea'     :
            return <Textarea {...rest} />
        case 'select'       :
            return<Select {...rest} />
        case 'selecttable'       :
                return<SelectTable {...rest} />
        case 'radio'        :
            return <RadioButtons {...rest} />
        case 'checkbox'     :
                return <CheckboxGroup {...rest} />
        case 'date'         :
            return <DatePicker {...rest} />
        case 'file'         :
            return <FileUpload {...rest} />
        case 'techexpert'         :
                return <FieldArrayTechExp {...rest} />
        case 'inputtable'         :
                return <InputTable {...rest} />        
        case 'ckEditor'         :
             return <CkEditer {...rest} />  
        case 'checkboxhorizantal'         :
                return <CheckboxHorizantal {...rest} />   
        case 'selectNACECode'       :
                return <AutoCompleteSelect {...rest} />       
        case 'field'       :
            return <Formikfield {...rest} />     
        case 'time'       :
                return <TimeControl {...rest} />  
        case 'multiselect'  :
            return <MultiSelectOption {...rest} />
    
        default             :
            return null
    }

}

export default FormikControl